"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _material = require("@mui/material");

var _utils = require("@mui/utils");

var _TextField = require("../TextField");

var _lodash = require("lodash");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["value", "onChange", "maxCharacters", "error", "characterCountDescription"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TextFieldWithCounter = function TextFieldWithCounter(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$maxCharacters = _ref.maxCharacters,
      maxCharacters = _ref$maxCharacters === void 0 ? 256 : _ref$maxCharacters,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$characterCountDe = _ref.characterCountDescription,
      characterCountDescription = _ref$characterCountDe === void 0 ? "characters out of 256" : _ref$characterCountDe,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(typeof value === "string" ? (0, _lodash.toArray)(value).length : 0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      counter = _useState2[0],
      setCounter = _useState2[1];

  (0, _react.useEffect)(function () {
    typeof value === "string" && setCounter((0, _lodash.toArray)(value).length);
  }, [value]);
  var onChangeHandler = (0, _react.useCallback)(function (event) {
    // Invoke props `onChange` function with event.
    typeof onChange === "function" && onChange(event);
    setCounter((0, _lodash.toArray)(event.target.value).length);
  }, [onChange]);
  var endAdornment = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.InputAdornment, {
    position: "end",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      mr: 1,
      px: 1,
      children: "".concat(counter, " / ").concat(maxCharacters)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      sx: _utils.visuallyHidden,
      "aria-live": "polite",
      "aria-atomic": true,
      children: "".concat(counter, " ").concat(characterCountDescription)
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.TextField, _objectSpread({
    value: value,
    InputProps: {
      endAdornment: endAdornment
    },
    onChange: onChangeHandler,
    error: counter > maxCharacters || error
  }, rest));
};

var _default = TextFieldWithCounter;
exports.default = _default;